import * as R from 'ramda'
import {
  DBFind,
  DBFindOne,
  DBInsert,
  DBRemove,
  DBRemoveMany,
  DBUpdateOne,
} from '@weblite/persist'

const SEEN_MENTION_COLLECTION = 'seenMentionSync'

interface SeenMentionPatchSync {
  roomId: string
  events: Record<number, number>
}

export async function set(roomId: string, seen: number) {
  const { nextKey } = (await DBFindOne(SEEN_MENTION_COLLECTION, roomId)) || {}
  if (nextKey) {
    await DBUpdateOne(SEEN_MENTION_COLLECTION, roomId, {
      $inc: { nextKey: 1 },
      $set: { [`events.${nextKey}`]: seen },
    })
  } else {
    await DBInsert(SEEN_MENTION_COLLECTION, {
      nextKey: 2,
      seen,
      roomId,
      events: { '1': seen },
    })
  }
}

export async function getAll() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const seenPatches: SeenMentionPatchSync[] = await DBFind(
    SEEN_MENTION_COLLECTION,
  )

  async function unsetSeenPatch() {
    await Promise.all(
      seenPatches.map(seenPatch =>
        DBUpdateOne(SEEN_MENTION_COLLECTION, seenPatch.roomId, {
          $unset: R.fromPairs(
            R.keys(seenPatch.events).map(key => [`events.${key}`, 1]),
          ),
        }),
      ),
    )
  }

  const pruneList: string[] = []

  const items = seenPatches
    .map(seenPatch => {
      if (R.isEmpty(seenPatch.events)) {
        pruneList.push(seenPatch.roomId)
        return null
      }
      return { seen: R.values(seenPatch.events), roomId: seenPatch.roomId }
    })
    .filter(Boolean)

  if (pruneList.length) await DBRemoveMany(SEEN_MENTION_COLLECTION, pruneList)

  return { items, del: unsetSeenPatch }
}

/** Remove connected fields */
export async function del(roomId: string): Promise<void> {
  await DBRemove(SEEN_MENTION_COLLECTION, roomId)
}
